import '/assets/scss/style.scss';
import '/assets/scss/inn-styles.scss';
window.newBGVideo = newBGVideo;



$(document).ready(function() {
	if(isLive == '0') {
        $('html').addClass('staging');
    }
	//Browser Specs
	//ie11
	if(navigator.userAgent.match(/Trident.*rv:11\./)) {
	    $('body').addClass('ie11');
	}
	var bgVideoElement = $('#bg-video');
	if (bgVideoElement.length) {
		newBGVideo.Init(bgVideoElement);
	}
	
	//ie10
	var doc = document.documentElement;
	var user_agent;
	doc.setAttribute('data-useragent', navigator.userAgent);
	
	//android
	if(navigator != undefined && navigator.userAgent != undefined) {
        user_agent = navigator.userAgent.toLowerCase();
        if(user_agent.indexOf('android') > -1) { // Is Android.
            $(document.body).addClass('android');
        }
    }

    //chrome
    var is_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
	if (is_chrome) {
	    $('body').addClass('chrome');
	}
	
	//pc or windows
	if (navigator.appVersion.indexOf("Mac")!=-1) {
		$('body').addClass('mac');
	} else {
		$('body').addClass('pc');
	}


	$(".ie7 #main_nav").before('<div class="clear_R"></div>');
	$(".ie7 .new_row").before('<div class="clear_L"></div>');


    /*
	window.vertically_center = function(_item, fadein){
		if(fadein){
		setTimeout(function() {
			$( _item ).show();
			$( _item ).animate({ 'opacity':'0' , 'marginTop':'0' }, 0);
			$( _item ).animate({ 'opacity':'1' , 'marginTop': -($( _item ).outerHeight(false)/2) }, 1750, "easeOutQuad").addClass('vert_center');
		}, 1000);
		}
		else{
			$( _item ).css({ 'marginTop': -($( _item ).outerHeight(false)/2) });
		}
	};

	$(window).on('load resize',function(){
		$( ".vert_center" ).each(function() {
			vertically_center($(this),false);
		});
	});
    */
	
	/* smooth scrolling */
	$('a[href*="#"]:not([href="#"])').on('click',function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html,body').animate({
				scrollTop: target.offset().top
			}, 750);
			return false;
			}
		}
	});
    
    $( ".content_contain .sibling_link" ).hover(
		function() {
			$(this).parent().siblings("section").find("a").addClass('hovered_sibling');
		},
		function() {
			$(this).parent().siblings("section").find("a").removeClass('hovered_sibling');
		}
	);
    
    $('.icon-new-tab').each(function(){
        var div = '<div class="link-icon-wrapper">';
        div += '<img src="/assets/images/icons/new-tab.png" alt="Opens link in a new tab"/>';
        div += '</div>';
        $(this).prepend(div);
    });
    $('.icon-view-pdf').each(function(){
        var div = '<div class="link-icon-wrapper">';
        div += '<img src="/assets/images/icons/pdf.png" alt="Opens PDF for viewing"/>';
        div += '</div>';
        $(this).append(div);
    });

    NavisIntegration.Init();
    
    /*
     * ADA related stuff
     */
    
    // Add skip link target
    if(!$('h1').length) {
        if($('html').hasClass('staging')) {
            //alert('Staging server warning. No H1 on page!');
        }
    }
    else {
        $('h1').attr('id', 'main-content');
    }
    
    // Set focus on skip link click
    $('.skip-link').on('click', function(){
        var skipTo = $("#"+this.href.split('#')[1]);
        skipTo.attr('tabindex', '0');
        skipTo.focus();
    });
    
    EventList.Init();
    
    // Set tabindex for TripAdvisor link that is controlled by external JS
    setTimeout(function(){
        $('#TA_socialButtonBubbles437 a').attr('tabindex', '-1');
    },1500);
    
    // Control to show iframe focus
    if($('iframe#pano').length) {
        $(document).on('focusout', function(){
            setTimeout(function(){
                // using the 'setTimout' to let the event pass the run loop
                if (document.activeElement instanceof HTMLIFrameElement) {
                    $(document.activeElement).addClass('focused');
                    $('html').addClass('iframe-focus');
                }
             },50);
        });
        $(document).on('focusin', function(){
            if($('html').hasClass('iframe-focus')) {
                $('html').removeClass('iframe-focus');
                $('iframe').removeClass('focused');
            }
        });
    }
    
    var v = /\?video\=|&video\=/i.test(location.href);
	$(".yt_videolink").click(function() {
		$.fancybox.open({
			'src'			: this.href,
			'type'			: 'iframe',
			'opts'			: {
				'afterShow': function() {
					$('.fancybox-iframe').focus();
					$('.fancybox-close').attr('tabindex', 0);
				},
				'afterClose': function() {
					$('.yt_videolink').first().focus();
				}
			},
		});

		return false;
	});

	if(v){ $(".yt_videolink").trigger('click'); }

    $('.jump_links a').on('click', function(){
        var skipTo = $("#"+this.href.split('#')[1]);
        skipTo.focus();
    });
    
    // Accessibility view room change
    $('#rooms-flyout .plus').on('click', function (e) {
        e.preventDefault();
        var currentRooms = $('#booking-widget .room-row').length;
        
        if (currentRooms < 4) {
            var newRow = $('#booking-widget .room-row').first().clone(true);
            var newRowNum = (currentRooms + 1);            
            newRow.find('legend').text('Room ' + newRowNum)
            newRow.find('label').each(function () {
                $(this).attr('for', $(this).attr('for').replace('r1', 'r' + newRowNum));
            });
            newRow.find('select').each(function () {
                var slOldName =  $(this).attr('id').replace('r1', 'r' + newRowNum);        
                $(this).attr('name', $(this).attr('name').replace('r1', 'r' + newRowNum));
                $(this).attr('id', $(this).attr('id').replace('r1', 'r' + newRowNum));
                $(this).on('change', function(r) {
                    $('#' + slOldName ).val($(this).val());
                });
            });
            newRow.find("input:checkbox").each(function () {         
                var cbOldName =  $(this).attr('id').replace('r1', 'r' + newRowNum);            
                $(this).attr('name', $(this).attr('name').replace('r1', 'r' + newRowNum));
                $(this).attr('id', $(this).attr('id').replace('r1','r' + newRowNum));
                $(this).on('change', function(r) {
                    $('#' + cbOldName ).val($(this).val());
                });
            });

            if (currentRooms == 3) { $(this).css("display", "none"); }
            
            currentRooms++;

            $('#roomcount').val(currentRooms);            

            $('#booking-widget #rooms-flyout .room-row').last().after(newRow);
        }
    });
    $('#rooms-flyout .minus').on('click', function (e) {
        e.preventDefault();
        // Remove rooms
        $('#booking-widget .plus').css("display", "initial");
        $('#booking-widget #rooms-flyout .room-row').last().remove();
        var currentRooms = $('#booking-widget .room-row').length;
        $('#roomcount').val(currentRooms);
    });

    // Accessibility view room change
    $('body').on('change', 'form#res_widget_form #rooms', function () {
        var currentRooms = $('form#res_widget_form .room-row').length;
        
        var newRooms = $(this).val();

        var roomDiff = newRooms - currentRooms;

        if (roomDiff > 0) {
            // Add rooms
            for (var i = 0; i < roomDiff; i++) {
                var newRow = $('form#res_widget_form .room-row').first().clone(true);
                var newRowNum = 'r' + (currentRooms + i + 1);

                newRow.find('label').each(function () {
                    $(this).attr('for', $(this).attr('for').replace('r1', newRowNum));
                });

                newRow.find('select').each(function () {
                    $(this).attr('name', $(this).attr('name').replace('r1', newRowNum));
                    $(this).attr('id', $(this).attr('id').replace('r1', newRowNum));
                });

                $('form#res_widget_form .field-switch').append(newRow);
            }
            var m = roomDiff;
            if (roomDiff == 1) {
                m += ' new room has been added.';
            }
            else {
                m += ' new rooms have been added.';
            }
            $('#res-form-message').html(m);
        }
        else if (roomDiff < 0) {
            // Remove rooms
            for (var i = 0; i > roomDiff; i--) {
                $('form#res_widget_form .room-row').last().remove();
            }
            var m = Math.abs(roomDiff);
            if (roomDiff == -1) {
                m += ' new room has been removed.';
            }
            else {
                m += ' new rooms have been removed.';
            }
            $('#res-form-message').html(m);
        }
    });

    // ADA fix for owl carousels
    $('.owl-carousel').on('keydown', function(e){
        var owl = $(this);

        switch(e.keyCode) {
            case 37: // left arrow
                owl.trigger('owl.prev');
                return false;
            case 39: // right arrow
                owl.trigger('owl.next');
                return false;
        }
    });
    
    // Add rel="noopener" to any links that need it
    $('a').each(function(i,a){
        var target = $(a).attr('target');

        if(target === '_blank') {
            $(a).attr('rel', 'noopener');
        }
    });
    $("#map-click-image").on('click', MapClick.Click);
});


//Window onLoad
$(window).on('load',function() {

    /*if($(window).width() > 480 && !$("body").hasClass('home')){
        vertically_center( $( ".header_txt" ), true );
    }*/

    // Auto-init for owl sliders
    $('.owl-carousel').each(function () {
        let count_children = $(this).children('.item').length;
        if(count_children == 1 && !($(this).hasClass('one'))) {
            $(this).addClass('one');
        }
        let isHome = $("#home_top2024").length > 0 ?  true : false;
        if(count_children > 1) {
            $(this).owlCarousel({
            items:1,
            smartSpeed:700,
            autoplay: isHome,
            autoplayTimeout: isHome ? 1200 : 0,
            loop:true,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            nav: !isHome,
            navText: ['<span class="icon"><svg><title>long arrow</title><use xlink:href="/assets/images/icons/icons.svg#long-arrow" /></svg></span> Previous', 'Next <span class="icon"><svg><title>long arrow</title><use xlink:href="/assets/images/icons/icons.svg#long-arrow" /></svg></span>'],
            dots:false
            }).on('translated.owl.carousel', function(e){
                var item = $(this).find('.owl-item.active'),
                this_alt = item.find('img').attr('alt'),
                this_aria = item.find('img').attr('aria-label'),
                text;

                if(typeof this_aria === 'undefined') { text = this_alt; } else { text = this_aria; }

                $(this).next('.img_dsc').text(text);
            });

        }
    });

    // Auto-init for owl sliders
    // $('.owl-init').each(function(){
    //     $(this).owlCarousel({
	// 		navigation : true,
	// 		slideSpeed : 700,
	// 		paginationSpeed : 700,
	// 		singleItem:true,
	// 		navigationText:["previous","next"],
	// 		stopOnHover:true,
	// 		addClassActive:true,
	// 		responsive: true,
	// 		afterAction: function(){ this.$elem.next(".img_dsc").text( $(this.$owlItems[this.currentItem]).find('img').attr('alt') ); }
	// 	});
    // });
});
window.ApiLoaded = function() {
    var Settings = MapClick.Settings();
    MapClick.map = new google.maps.Map(document.getElementById("map-canvas"),Settings);
    $("#map-click-image").fadeOut(250, MapClick.LoadMarker);
}
var MapClick = {
    loaded: false,
    segment: null,
    map: null,

    Click: function(){
        if(MapClick.loaded){
            return;
        }
        MapClick.loaded = true;
        MapClick.segment = $(this).data('segment');
        jQuery.ajax({
            url: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyChM_cQlsFfjGMKdsXKHFDDsiRrRZAPcU4&loading=async&callback=ApiLoaded',
            dataType: 'script',
            success: function(){
                // google.maps.event.addListenerOnce(map, 'idle', function(){
                //     // do something only the first time the map is loaded
                //     console.log(1)
                // });
            },
            async: true
        });
        if(typeof(dataLayer) !== 'undefined') {
            dataLayer.push({
                'event': 'Map Click Load',
                'map_click_status':'click'
            });
        }
    }, 

    LoadMarker: function(){
        var position= null;
        var icon= null;
        var mapname= null;
        switch(MapClick.segment){
            case 'lodge':
                position=new google.maps.LatLng(40.271230, -76.676818);
                icon='/assets/images/sprites/hl_pin.png';
                mapname= "Hershey Inn & Suites Map"
                break;
        }
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(40.271230, -76.676818),
            icon: icon,
            animation: google.maps.Animation.DROP,
            map: MapClick.map,  
        });
        switch(MapClick.segment){
            case 'lodge':
                google.maps.event.addListener(marker, 'click', function() {
                    window.open( 'http://maps.google.com/maps?saddr=Current%20Location&daddr=Hershey+Lodge,+University+Drive,+Hershey,+PA' , '_blank');
                });
                break;
        }
        google.maps.event.addListenerOnce(MapClick.map, 'tilesloaded', function() {
            document.getElementsByTagName('iframe')[0].title = "Hershey Inn & Suites Map";
        });
    },


    Settings: function(){
        var center= null;
        switch(MapClick.segment){
            case 'lodge': 
                center=new google.maps.LatLng(40.271230, -76.676818);
                break;
        }
        
        var styles= {
            center: new google.maps.LatLng(40.271230, -76.676818),
            zoom: 15,
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{
            "stylers": [
            { "saturation": -60 },
            { "hue": "#813234" }
            ]},{},{}],
            zoomControlOptions: { position: google.maps.ControlPosition.LEFT_CENTER },
            panControlOptions: { position: google.maps.ControlPosition.LEFT_CENTER }
            };
        
        return styles;
    },
    
}
var NavisIntegration = {
    // VERY IMPORTANT, make sure the property specific value is set here
    propertyValue: '8443301797',
    
    Init: function() {
        // Check for Navis function to make sure the script is installed
        if(typeof(AppendNavisKeywordToLink) === 'function') {
            setTimeout(function(){
                NavisIntegration.SetATags();
                NavisIntegration.SetForms();
            },1500);
        }
        else {
            console.log('Navis Integration called but either the navis.js file is not installed or there is an error.');
        }
    },
    
    SetATags: function() {
        $("a[href^='https://reservations.hersheypa.com/']").each(function(i,a){
            // Get/check the id
            var aID = $(a).prop('id');
            if(aID == '') {
                // No ID on the a tag
                var randomNum = Math.round( Math.random( ) * 100000 );
                aID = 'booking-link-'+randomNum;
                $(a).attr('id', aID);
            }
            AppendNavisKeywordToLink(aID);
        });
    },
    
    SetForms: function() {
        $("form[action^='https://misc.hersheypa.com/assets/hrs/redir/']").each(function(i,form){
            // Does the hidden NCK field exist?
            var NCK = $(form).find('input[name=NCK]');
            if(!NCK.length) {
                // Doesn't exist, insert it
                NCK = $('<input type="hidden" name="NCK" />');
                $(form).prepend(NCK);
            }
            
            // Get/set the input ID
            var ID = NCK.attr('id');
            if(typeof(ID) === 'undefined') {
                var randomNum = Math.round( Math.random( ) * 100000 );
                ID = 'nck-link-'+randomNum;
                NCK.attr('id', ID);
            }
            
            // Verify the value
            var value = NCK.val();
            if(typeof(value) === 'undefined' || value != NavisIntegration.propertyValue) {
                NCK.val(NavisIntegration.propertyValue);
            }
            NavisSetHiddenKeywordFieldD(ID, NavisIntegration.propertyValue);
        });
    }
};


/*
 * A list for upcoming events that defaults to a scrolling marquee on desktop
 * but can also serve as a list for mobile and accessibility.
 */
var EventList = {
    mode: null,
    view: 'scroll',
    scroll: null,
    delay: 6000,
  
    Init: function(){
        if($(window).width() > 1024) {
            this.mode = 'desktop';
            // Start scrolling
            EventList.Scroll.Start();
            
            $( "#events" ).hover(
                function() {
                    EventList.Scroll.Stop();
                },
                function() {
                    EventList.Scroll.Start();
                }
            );
        }
        else {
            this.mode = 'mobile';
        }
        
        $('.events-view-switch').on('click', function(){
            EventList.Switch(this);
        });
    },
    
    Switch: function(a) {
        if(EventList.mode == 'mobile') {
            return;
        }
        
        var view = $(a).data('view');
        
        if(view == 'marquee') {
            // Switch to list
            EventList.SwitchToList();
        }
    },
    
    SwitchToList: function() {
        EventList.view = 'list';
        EventList.Scroll.Stop();
        
        $('#events > li').css({
            'display': 'block',
            'opacity': 1,
            'marginTop': '0px'
        });
        
        $('#events > li a').attr('tabindex', 0);
        
        $('#upcoming_events > div').animate({
            height: $('#upcoming_events > div').get(0).scrollHeight
        }, 1000, function(){
            $(this).height('auto');
        });
        
        $('#events > li a').first().focus();
        
        // Hide the button
        $('.events-view-switch').hide();
    },
    
    Scroll: {
        
        Start: function() {
            if(EventList.view != 'scroll') {
                return;
            }
            
            EventList.scroll = setInterval( function(){ 
                EventList.Scroll.Loop(); 
            }, 
            EventList.delay );
        },
        
        Stop: function() {
            if(EventList.scroll) {
                EventList.scroll = clearInterval(EventList.scroll);
            }
        },

        Loop: function() {
            var $current = $('#events > li.active');
            if(!$current.length) {
                $current = $('#events > li').first();
                $current.show();
            }
            $current.css({'display':'list-item'});
            var $next;
            
            $current.animate({ 'opacity':'0' , 'marginTop':'-10px' }, 450, function() {
                $current.css({'display':'none'});
                $next = $(this).next('li').length ? $(this).next('li') : $(this).parent().children().first();
                $next.show();
                $next.css({'margin-top':'10px'});
                $next.animate({ 'opacity':'0'}, 0);
                $next.animate({ 'opacity':'1' , 'marginTop':'0' }, 800, "easeOutQuad");
                $next.addClass('active');
                $current.removeClass('active');
            });
        }
    }
};


/*
 * Add ADA behavior to the existing nav
 */
var Nav = {
    ul: null,
    tops: null,
    setFocus: true,

    Init: function() {
        this.ul = $('#main_nav > ul');
        
        this.AddMarkup();
        
        this.tops = this.ul.find('.menu-top');
    },

    BindDesktop: function() {
        this.ul.find('>li').hoverIntent({
			over: function () {
                if( $('ul', this).length ){
                    Nav.setFocus = false;
                    Nav.Open(this);
                }
			},
			timeout: 250,
			out: function () {
                if( $('ul', this).length ){
                    Nav.Close(this);
                }
			}
		});
        
        this.ul.find('>li').on('click', function(){
            if($(this).hasClass('opened') || !$(this).find('ul').length) {
                return true;
            }
            else {
                Nav.Open(this);
                return false;
            }
        });
        
        this.ul.on('keydown', function(e){
            switch(e.keyCode) {
                case 32: // space bar
                case 13: // enter key
                    // Are we in a submenu?
                    if(Nav.InSubmenu()) {
                        return true;
                    }
                    else {
                        var $menuTop = $(':focus').parents('.menu-top');
                        if($menuTop.hasClass('opened') || !$menuTop.find('ul').length) {
                            return true;
                        }
                        else {
                            Nav.Open($(':focus').parents('.menu-top'));
                            return false;
                        }
                    }
                case 27: // escape key
                    if(Nav.InSubmenu()) {
                        var topMenu = $(':focus').parents('li.menu-top');
                        Nav.Close(topMenu);
                        topMenu.find('a').first().focus();
                        return false;
                    }
                    return true;
                case 37: // left arrow
                    Nav.Arrow.Left();
                    return false;
                case 38: // up arrow
                    Nav.Arrow.Up();
                    return false;
                case 39: // right arrow
                    Nav.Arrow.Right();
                    return false;
                case 40: // down arrow
                    Nav.Arrow.Down();
                    return false;
                case 36: // home key
                    if(Nav.InSubmenu()) {
                        var $anchors = $(':focus').parents('ul[role=menu]').find('li:not(.mble_only) a');
                        $anchors.first().focus();
                    }
                    else {
                        Nav.tops.first().find('a').focus();
                    }
                    return false;
                case 35: // end key
                    if(Nav.InSubmenu()) {
                        var $anchors = $(':focus').parents('ul[role=menu]').find('li:not(.mble_only) a');
                        $anchors.last().focus();
                    }
                    else {
                        Nav.tops.last().find('a').focus();
                    }
                    return false;
                case 9: // tab key
                    // Should leave menu, so close any open submenus
                    var openMenu = Nav.ul.find('li.opened');
                    if(openMenu.length) {
                        Nav.Close(openMenu);
                    }
                    return true;
            }

            if(e.keyCode >= 65 && e.keyCode <= 90) {
                // Character key pressed
                Nav.Goto.NextLetter(String.fromCharCode(e.which));
                return false;
            }
        });
    },
    
    Arrow: {
        
        Left: function() {
            Nav.Goto.PreviousTop(Nav.IsOpen());
        },

        Right: function() {
            Nav.Goto.NextTop(Nav.IsOpen());
        },
        
        Up: function() {
            if(Nav.InSubmenu()) {
                var $anchors = $(':focus').parents('ul[role=menu]').find('li:not(.mble_only) a');
                var currentIndex = $anchors.index($(':focus'));
                var nextIndex = currentIndex - 1;
                if(nextIndex < 0) {
                    nextIndex = $anchors.length - 1;
                }
                
                $anchors.eq(nextIndex).focus();
            }
            else {
                Nav.setFocus = 'last';
                Nav.Open($(':focus').parents('li.menu-top'));
            }
        },
        
        Down: function() {
            if(Nav.InSubmenu()) {
                var $anchors = $(':focus').parents('ul[role=menu]').find('li:not(.mble_only) a');
                var currentIndex = $anchors.index($(':focus'));
                var nextIndex = currentIndex + 1;
                if(nextIndex >= $anchors.length) {
                    nextIndex = 0;
                }
                
                $anchors.eq(nextIndex).focus();
            }
            else {
                Nav.Open($(':focus').parents('li.menu-top'));
            }
        }
    },
    
    Goto: {
      
        PreviousTop: function(open) {
            var currentTop = $(":focus").parents('.menu-top');
            Nav.Close(currentTop);
            
            var currentIndex = Nav.tops.index(currentTop);
            var previousIndex = currentIndex - 1;
            if(previousIndex < 0) {
                previousIndex = Nav.tops.length - 1;
            }
            
            Nav.tops.eq(previousIndex).find('a').focus();
            
            if(open) {
                Nav.Open(Nav.tops.eq(previousIndex));
            }
        },

        NextTop: function(open) {
            var currentTop = $(":focus").parents('.menu-top');
            Nav.Close(currentTop);
            
            var currentIndex = Nav.tops.index(currentTop);
            var nextIndex = currentIndex + 1;
            if(nextIndex >= Nav.tops.length) {
                nextIndex = 0;
            }
            
            Nav.tops.eq(nextIndex).find('a').focus();
            
            if(open) {
                Nav.Open(Nav.tops.eq(nextIndex));
            }
        },
        
        NextLetter: function(letter) {
            var $elements = null;
            if(Nav.InSubmenu()) {
                $elements = $(':focus').parents('ul[role=menu]').find('li:not(.mble_only) a');
            }
            else {
                $elements = Nav.ul.find('> li > a');
            }
            
            var focusIndex = 0;
            var matchingElements = [];
            $elements.each(function(i,a){
                if($(a).is(':focus') || $(a).parent().is(':focus')) {
                    focusIndex = i;
                }
                var aText = $.trim($(a).text());
                var firstLetter = aText.substr(0,1).toUpperCase();
                if(firstLetter == letter) {
                    matchingElements.push(i);
                }
            });
            if(!matchingElements.length) {
                return;
            }

            var matchFound = false;
            var leastMatch = 999;
            $.each(matchingElements, function(i,e){
                if(e > focusIndex) {
                    matchFound = true;
                    $elements.eq(e).focus();
                    return false;
                }
                if(e < leastMatch) {
                    leastMatch = e;
                }
            });

            if(!matchFound && leastMatch < $elements.length) {
                $elements.eq(leastMatch).focus();
            }
        }
    },
    
    Open: function(li) {
        if(!$(li).find('ul').length) {
            return;
        }
        $(li).addClass('opened');
        
        $('ul', li).slideDown(500, function(){
            if(Nav.setFocus == 'last') {
                $(li).find('ul a').last().focus();
            }
            else if(Nav.setFocus) {
                $(li).find('ul a').first().focus();
            }
            Nav.setFocus = true;
        });
        $( "#blackout" ).css('display','block');
    },
    
    Close: function(li) {
        $(li).removeClass('opened');
        
        $('ul', li).slideUp(400);
        if( !$('#main_nav .opened').length ){  
            $( "#blackout" ).css('display','none'); 
        }
    },
    
    IsOpen: function() {
        if(Nav.ul.find('.opened').length) {
            return true;
        }
        return false;
    },
    
    InSubmenu: function() {
        var ulParent = $(':focus').parents('ul').first();
        
        if(ulParent.attr('role') == 'menu') {
            return true;
        }
        
        return false;
    },
    
    /*
     * Add roles, aria values, ect as needed to make the nav compliant
     */
    AddMarkup: function() {

        Nav.ul.attr({
            'role': 'menubar',
            'aria-label': 'Main Menu'
        });
        
        // Start cycling through nested elements
        Nav.ul.find('> li').each(function(i, li){
            $(li).attr('role', 'none').addClass('menu-top');
            
            var $subnav = $(li).find('ul');
            
            var $a = $(li).find('> a');
            $a.attr({
                'role': 'menuitem',
                'tabindex': i==0?0:-1
            });
            
            if($subnav.length) {
                $a.attr({
                    'aria-haspopup': 'true'
                });
                
                $subnav.attr({
                    role: 'menu'
                });
                
                var $subli = $subnav.find('li');
                $subli.attr({
                    role: 'none'
                });
                
                var $suba = $subnav.find('a');
                $suba.attr({
                    role: 'menuitem',
                    tabindex: -1
                });
            }
        });
    }
};


jQuery(function($) {
     var path = window.location.href; 
     $('#nav a, .ftr2024 a').each(function() {
        
        if (path.indexOf(this.href) > -1)  {
        //   if (this.href === path) {
        $(this).addClass('active');
        }
     });
});

  // SPOTLIGHTR Video

var newBGVideo = {
	el: null,
	spotlightr: null,
	spotlightId: null,

	Init: function ($el) {
		this.el = $el;

		if(typeof($el.data('spotlightr')) != 'undefined' && $el.data('spotlightr') != null) {

			this.spotlightId = $el.data('spotlightr');
			var mobileSize = $el.data('mobile');
			if (typeof mobileSize === 'undefined') {
				mobileSize = 768;
			} 
			if($(window).width()<=mobileSize){
				this.spotlightId = $el.data('spotlightr-mobile') ? $el.data('spotlightr-mobile') : $el.data('spotlightr');
			}
			var tag = document.createElement("script");
			tag.src = "https://videos.cdn.spotlightr.com/assets/spotlightr.js";
			document.getElementsByTagName("head")[0].appendChild(tag);

            $el.append(`<iframe allow="autoplay" class="video-player-container spotlightr" data-playerid="${this.spotlightId}" allowtransparency="true" aria-label="Watch video detailing about this page" name="videoPlayer" allowfullscreen="false" src="https://videos.cdn.spotlightr.com/watch/${this.spotlightId}?muted=0&autoplay=1&loop=1&controls=0" watch-type="" frameborder="0" scrolling="no"> </iframe>`);		
		} 
		$("#pause-btn").on("click", function(e) {
			e.preventDefault();
			if($(this).hasClass("paused")){
				newBGVideo.Play();
			}
			else if($(this).hasClass("playing")){
				newBGVideo.Pause();
			}
		});

		let cc_btn = $("#cc-btn");
		if(cc_btn.length) {
			let btn_controls = $("#bg-video").find(".controls"),
				hero_img = $(".hero-img"),
				hero_text = $("#hero .hero-txt.move"), hero_txt_margin = hero_text.css('margin-top');
            if(btn_controls.length) {
                function setControlsPosition() {
                    var bookingWidget = $('#booking-widget');
                    var hero = $('#hero');
                    var winWidth = $(window).width();
                    if (winWidth <= 500 && hero.length) {
                        var heroHeight = hero.outerHeight();
                        btn_controls.css('top', (heroHeight - 70) + 'px');
                    } else if (winWidth <= 660 && hero.length) {
                        var heroHeight = hero.outerHeight();
                        btn_controls.css('top', (heroHeight - 120) + 'px');
                    } else if (winWidth <= 768 && hero.length) {
                        var heroHeight = hero.outerHeight();
                        btn_controls.css('top', (heroHeight - 150) + 'px');
                    } else if(hero.length && bookingWidget.length) {
                        var heroHeight = hero.outerHeight();
                        var bookingWidgetHeight = bookingWidget.outerHeight();
                        btn_controls.css('top', ((heroHeight - (bookingWidgetHeight + 30))) + 'px');
                    } else if(hero.length) {
                        var heroHeight = hero.outerHeight();
                        btn_controls.css('top', (heroHeight - 50) + 'px');
                    } else {
                        btn_controls.css('top', '20px');
                    }
                }
                setControlsPosition();
                $(window).on('resize', setControlsPosition);
            }
			
			$("#cc-btn").on("click", function(e) {
				e.preventDefault();
                let  captioned = 'captioned';
				if($(this).hasClass(captioned)){
				    newBGVideo.HideCaption($(this), captioned);
				}
				else{
				    newBGVideo.ShowCaption($(this), captioned);
				}

			});
		}
        $("#mute-btn").on("click", function(e) {
            e.preventDefault();
            if($(this).hasClass("muted")){
                newBGVideo.Unmute(this);
            } else {
                newBGVideo.Mute(this);
            }
        });

		$(document).on('keydown', function(e){
			if(e.keyCode == 32 || e.which == 32) {
				// Space bar press
				$("#pause-btn").trigger('click');
				if(!$('input:focus').length) {
					e.preventDefault();
				}
			}
		});
	},
    Mute: function(btn) {
        if (typeof spotlightrAPI === "function") {
            spotlightrAPI(this.spotlightId, 'volume', [0]);
        } else {
            console.log("function to mute is not loaded yet");
        }
        $(btn).addClass("muted");
    },
    Unmute: function(btn) {
        if (typeof spotlightrAPI === "function") {
            spotlightrAPI(this.spotlightId, 'volume', [1]);
        } else {
            console.log("function to unmute is not loaded yet");
        }
        $(btn).removeClass("muted");
    },

	HideCaption: function (cc, captioned) {
        if (typeof spotlightrAPI === "function") {
            spotlightrAPI(this.spotlightId, 'captions', false);
        } else {
            console.log("function to hide caption is not loaded yet");
        }
        cc.removeClass(captioned);
	},

	ShowCaption: function (cc, captioned) {
        if (typeof spotlightrAPI === "function") {
            spotlightrAPI(this.spotlightId, 'captions', true);
        } else {
            console.log("function to show caption is not loaded yet");
        }
        cc.addClass(captioned);
	},

	Play: function () {
		$("#pause-btn").addClass('playing').removeClass('paused');
		$("#pause-btn").html($("#pause-btn").html().replace('Play', 'Pause'));
		spotlightrAPI(this.spotlightId, 'play');
	},

	Pause: function () {
		$("#pause-btn").addClass('paused').removeClass('playing');
		$("#pause-btn").html($("#pause-btn").html().replace('Pause', 'Play'));
		spotlightrAPI(this.spotlightId, 'pause');
	}
};